export const RELEASE_KEY = 'workspace_release_2026_10'

export function readReleaseSession(local, session, hostname = '') {
  try {
    const role = local.getItem('auth_role') || session.getItem('auth_role') || ''
    const realm = ['superadmin', 'admin'].includes(role) ? 'admin'
      : ['tester', 'tester_no_media', 'tester_plus'].includes(role) ? 'tester'
        : role ? 'user' : hostname.startsWith('admin.') ? 'admin' : hostname.startsWith('test.') ? 'tester' : 'user'
    return local.getItem(`${realm}_token`) || session.getItem(`${realm}_token`)
      || (role ? local.getItem('access_token') || session.getItem('access_token') : '') || ''
  } catch { return '' }
}

export async function resolveWorkspaceVariant(fetcher, token, apiBase = '/api', signal) {
  if (!token) return 'stable'
  try {
    const response = await fetcher(`${apiBase}/admin/users/me/capabilities`, {
      headers: { Authorization: `Bearer ${token}` }, cache: 'no-store', signal,
    })
    if (!response.ok) return 'stable'
    const data = await response.json()
    return data?.workspace_release?.key === RELEASE_KEY && data.workspace_release.variant === 'canary'
      ? 'canary' : 'stable'
  } catch { return 'stable' }
}

export function validateStableManifest(manifest) {
  const stable = manifest?.stable
  const allowed = (path) => typeof path === 'string'
    && /^\/(?:_workspace\/stable\/)?assets\/[A-Za-z0-9_.-]+\.(js|css)$/.test(path)
  if (!stable || !allowed(stable.entry) || !stable.entry.endsWith('.js')
    || !Array.isArray(stable.styles) || !stable.styles.every((path) => allowed(path) && path.endsWith('.css'))) {
    throw new Error('Invalid stable workspace manifest')
  }
  return stable
}
